import { render } from "./MultilingualInput.vue?vue&type=template&id=1338095a&scoped=true"
import script from "./MultilingualInput.vue?vue&type=script&lang=js"
export * from "./MultilingualInput.vue?vue&type=script&lang=js"

import "./MultilingualInput.vue?vue&type=style&index=0&id=1338095a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1338095a"]])

export default __exports__